import React from "react"
import { Button, Modal, Tab, Tabs } from "react-bootstrap"
import { injectIntl } from "react-intl"
import IntlProps from "../../state/helpers/IntlProps"
import { RFBadge } from "../components/RFBadge"
import { paymentStatusesMessages } from "./PaymentStatusesMessages"
import "./modals.scss"

const rfPaymentStatus = [
    { status: "processing", label: "processingStatus", description: "processingDescription"}, 
    { status: "success", label: "successStatus", description: "successDescription"}, 
    { status: "failed", label: "failedStatus", description: "failedDescription"},
    { status: "canceled", label: "canceledStatus", description: "canceledDescription"},
] as const

const rfRefundStatus = [
    { status: "processing", label: "processingStatus", description: "refundProcessingDescription"}, 
    { status: "success", label: "successStatus", description: "refundSuccessDescription"}, 
    { status: "failed", label: "failedStatus", description: "refundFailedDescription"},
    { status: "canceled", label: "canceledStatus", description: "refundCanceledDescription"},
] as const

type OwnProps = {
    isOpen: boolean
    onClose: () => void
} 

const PaymentStatusesModal = (props: OwnProps & IntlProps) => {
    return (
        <Modal show={props.isOpen} onHide={props.onClose} centered={true} dialogClassName='payment-statuses-modal' >
            
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="h5">{props.intl.formatMessage(paymentStatusesMessages["modalTitle"])}</div>
                </Modal.Title>
            </Modal.Header>
            
            <Modal.Body>
                <Tabs defaultActiveKey={"payments"}>
                    
                    <Tab title={props.intl.formatMessage(paymentStatusesMessages["paymentTitle"])} eventKey="payments">
                        <div className="d-flex flex-column gap-4 pt-4 pb-2">
                            {rfPaymentStatus.map(({ status, label, description }) => (
                                <>
                                    <div className="d-flex gap-3">
                                        <div className="d-flex payment-statuses-modal-badge-width">
                                            <RFBadge status={status}>
                                                {props.intl.formatMessage(paymentStatusesMessages[label])}
                                            </RFBadge>
                                        </div>
                                        {props.intl.formatMessage(paymentStatusesMessages[description])}
                                    </div>
                                </>
                            ))}
                        </div>
                    </Tab>

                    <Tab title={props.intl.formatMessage(paymentStatusesMessages["refundTitle"])} eventKey="refunds">
                        <div className="d-flex flex-column gap-4 pt-4 pb-2">
                            {rfRefundStatus.map(({ status, label, description }) => (
                                <>
                                    <div className="d-flex gap-3">
                                        <div className="d-flex payment-statuses-modal-badge-width">
                                            <RFBadge status={status}>
                                                {props.intl.formatMessage(paymentStatusesMessages[label])}
                                            </RFBadge>
                                        </div>
                                        {props.intl.formatMessage(paymentStatusesMessages[description])}
                                    </div>
                                </>
                            ))}
                        </div>
                    </Tab>
                    
                </Tabs>
            </Modal.Body>

            <Modal.Footer>
                <Button type="button" className="btn btn-secondary" onClick={props.onClose}>
                    {props.intl.formatMessage(paymentStatusesMessages["close"])}
                </Button>
            </Modal.Footer>
            
        </Modal>
    )
}
export default injectIntl(PaymentStatusesModal)


// WEBPACK FOOTER //
// ./src/payment-processing/modals/PaymentStatusesModal.tsx